import { render, staticRenderFns } from "./EditTaskSchedule.vue?vue&type=template&id=820fcbbe"
import script from "./EditTaskSchedule.vue?vue&type=script&lang=js"
export * from "./EditTaskSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports